import { render, staticRenderFns } from "./Blaek.vue?vue&type=template&id=60bc9437&"
import script from "./Blaek.vue?vue&type=script&lang=js&"
export * from "./Blaek.vue?vue&type=script&lang=js&"
import style0 from "./Blaek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports